import { createContext } from 'react';

const ScriptContext = createContext({});

export default ScriptContext;
